export default __webpack_public_path__ + "static/media/vendor-online.995a6e17.svg";